module.exports = __webpack_public_path__ + "media/images/icons/duotoneicons/Home/Box-3a79c72e37dc3b2878daf5eebca1cee83fe91cf9dac9f3e873de69c419510d4a.svg";